import { useEffect, useRef, useState } from 'react';
import { brancherTirage } from '../lib/pull-to-refresh.js';

/**
 * Tirer pour rafraîchir sur la page qui l'appelle, et elle seule : le geste est branché au
 * montage, débranché au démontage. Le temps qu'elle est montée, `overscroll-behavior-y:
 * contain` sur <html> retire au navigateur son propre « tirer pour recharger » (Chrome dans un
 * onglet), qui rechargerait toute l'app au lieu des données.
 */
export function usePullToRefresh(onRefresh: () => Promise<void>): {
  distance: number;
  refreshing: boolean;
} {
  const [distance, setDistance] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const rappel = useRef(onRefresh);
  rappel.current = onRefresh;

  useEffect(() => {
    const html = document.documentElement;
    const avant = html.style.overscrollBehaviorY;
    html.style.overscrollBehaviorY = 'contain';
    const debrancher = brancherTirage(window, {
      enHaut: () => window.scrollY <= 0,
      bloque: () => document.querySelector('dialog[open]') !== null,
      surTirage: setDistance,
      onRefresh: async () => {
        setRefreshing(true);
        try {
          await rappel.current();
        } finally {
          setRefreshing(false);
        }
      },
    });
    return () => {
      debrancher();
      html.style.overscrollBehaviorY = avant;
    };
  }, []);

  return { distance, refreshing };
}
